import React from 'react';

import './Sort.css';

const Sort = props => {
    return(
        <div className="SortByDiv" >
        <p>Sort By:</p>
       <select onChange={props.onChange} value={props.value} className="sortSelect">
        <option value="title" >Title</option>
        {props.type==="classes" ? <option value="dataset" >Dataset</option>:<option value="classes" >Classes</option>}
        <option value="entities" >Entities</option>
        <option value="recommendations">Recommendations</option>
       </select >
       </div>
    );
};

export default Sort;